import { Box, BoxProps } from "@chakra-ui/react";

export function PageContainer(props: BoxProps) {
  return (
    <Box maxW={"4xl"} mx={"auto"} mb={"16"} w={"100%"} p={[3, 4]} {...props} />
  );
}
